import AppMentionInput from "./AppMentionInput";
import { AppMentionInputProps } from "./types";

export default AppMentionInput;

export type { AppMentionInputProps };
